import { AssetsPage } from 'features/assets';

export const AdminMainPage: React.FC = () => <AssetsPage />;
